import { useCallback } from "react";

export function useLoginErrorMessage({ error, t }) {
  return useCallback(() => {
    if (!error) return "";
    const errorCode = (error as unknown as { errorCode?: string })?.errorCode;
    const errorMessage = typeof error === 'string' ? error : (error as unknown as { message?: string })?.message ?? '';

    // Account locked or too many attempts
    if (
      errorCode === 'E0000069' ||
      errorCode === 'E0000047' ||
      errorMessage?.toLowerCase().includes('locked') ||
      errorMessage?.toLowerCase().includes('too many attempts')
    ) {
      return t("errorCodes.CUST_S1200002");
    }

    // Invalid credentials (always show the required custom message)
    if (
      errorCode === 'E0000004' ||
      errorMessage?.toLowerCase().includes('authentication failed') ||
      errorMessage?.toLowerCase().includes('invalid username or password')
    ) {
      return "The Email and/or password you entered doesn't match our record. Try again.";
    }

    // Invalid verification code (OTP/MFA)
    if (errorCode === 'E0000068') {
      return t("errors.invalidCode", "Invalid verification code");
    }

    // Default fallback
    return t("errors.genericError", "Something went wrong. Please try again.");
  }, [error, t]);
}
